import { UilFileTimes } from '@iconscout/react-unicons';
import ConditionalRender from 'base/ConditionalRender/ConditionalRender';
import { StandardButton } from 'base/StandardButton/StandardButton';
import { t } from 'i18next';
import { capitalizeFirstLetter } from 'utils/helpers';

interface DataNotFoundI {
  text?: string;
  fullHeight?: boolean;
  showButton?: boolean;
  onButtonClick?: () => void;
  buttonText?: string;
  showAsCard?: boolean;
  description?: string | string[];
}
export const DataNotFound = ({
  text,
  fullHeight = false,
  showButton = false,
  onButtonClick,
  buttonText,
  showAsCard = false,
  description
}: DataNotFoundI) => {
  return (
    <div
      className={`d-flex  align-items-center justify-center ${
        fullHeight ? 'h-screen' : ''
      } ${showAsCard ? 'py-10 flex-column form-card ' : ' gap-3'}`}
      id="data_not_found"
    >
      <UilFileTimes
        className={`${showAsCard ? 'fs-5' : ''} text-red-700`}
        size={showAsCard ? 50 : 30}
      />
      <p className={` font-semi-bold pt-3 ${showAsCard ? 'fs-5 mt-31' : ''}`}>
        {text || capitalizeFirstLetter(t('general.no_data'))}
      </p>
      <ConditionalRender
        condition={!!description && !Array.isArray(description)}
      >
        <p className="">{description}</p>
      </ConditionalRender>
      <ConditionalRender
        condition={!!description && Array.isArray(description)}
      >
        {(description as string[])?.map(item => {
          return (
            <div key={item} className="fs-8 text-body-quaternary">
              <p className="m-0 p-0">{item}</p>
            </div>
          );
        })}
      </ConditionalRender>
      <ConditionalRender condition={showButton}>
        <StandardButton
          fullWidth={false}
          className="btn-primary no-min-width mt-4 px-4"
          buttonText={buttonText || ''}
          onClick={() => {
            onButtonClick?.();
          }}
        />
      </ConditionalRender>
    </div>
  );
};
